export const version = "ethers/5.6.0";
//# sourceMappingURL=_version.js.map